import { AxiosResponse } from 'axios';
import requestInstance from '../../utils/instance-utils';

export const getAllActiveSkills = (
    clientId: number,
    ecrId: string,
    isWhitelisted: boolean
) =>
    requestInstance.get(
        `/skills/all-active-skill?clientId=${clientId}&ecrId=${ecrId}`,
        { headers: { 'X-Is-Whitelisted': String(isWhitelisted) } }
    );

export const getAllHSearchSkills = (payload: any, isWhitelisted: boolean) =>
    requestInstance.post('skills/search-skill', payload, {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });

export const postAddFavoriteFilters = (payload: any) =>
    requestInstance.post('user/add-favorites-filter', payload);

export const getPEContentFromHSCS = (
    eid: any,
    isWhitelisted: boolean
): Promise<AxiosResponse<any>> =>
    requestInstance.get(`skills/hscs-patient-education?eid=${eid}`, {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getFavoriteFilters = () =>
    requestInstance.get('user/get-favorites-filter');

export const editFavoriteFilters = (payload: any) =>
    requestInstance.patch('user/edit-favorites-filter', payload);

export const getQuickLinks = (
    courseIds: string,
    clientId: number,
    isWhitelisted: boolean
) =>
    requestInstance.get(
        `/skills/quick-links?courseIds=${courseIds}&clientId=${clientId}`,
        { headers: { 'X-Is-Whitelisted': String(isWhitelisted) } }
    );

export const getPEAutoSuggestTitles = (
    keyword: string,
    nursingSkillsClientId: string,
    isWhitelisted: boolean
) =>
    requestInstance.get(
        `skills/pe-auto-suggest?keyword=${keyword}&nursingSkillsClientId=${nursingSkillsClientId}`,
        { headers: { 'X-Is-Whitelisted': String(isWhitelisted) } }
    );

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getRecentViewedSkills = () =>
    requestInstance.get('/user/recent-viewed-skills');

export const getKeywordAutoSuggestTitles = (
    keyword: string,
    nursingSkillsClientId: string,
    isWhitelisted: boolean
) =>
    requestInstance.get(
        `skills/keyword-auto-suggest?keyword=${keyword}&nursingSkillsClientId=${nursingSkillsClientId}`,
        { headers: { 'X-Is-Whitelisted': String(isWhitelisted) } }
    );

export const getBrowseSkillsOrPatientEducations = (
    payload: any,
    isWhitelisted: boolean
) =>
    requestInstance.post('skills/browse', payload, {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });
